import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles((theme) =>
  createStyles({
    container: {
      display: 'grid',
      gridTemplateColumns: '220px 1fr',
      height: '100%',
    },
    currentTabContainer: {
      display: 'flex',
      flexDirection: 'column',
      padding: '4rem 2.5rem',
      minHeight: '0',
      '& .MuiTypography-h1': {
        marginBottom: theme.spacing(4),
      },
    },
    aside: {
      display: 'flex',
      flexDirection: 'column',
      backgroundColor: theme.palette.background.default,
      '& h1': {
        padding: '4rem 2rem',
      },
    },
    tabs: {
      padding: ' 0 1rem',
      flex: 1,
    },
    tab: {
      fontSize: '1.4rem',
      fontWeight: 500,
      fontFamily: 'Cabin, sans-serif',
      textTransform: 'none',
      padding: '0.5rem 0',
      borderRadius: '0.5rem',

      '&.Mui-selected': {
        backgroundColor: '#CCCEE5',
      },

      '&.MuiTab-labelIcon': {
        minHeight: 'min-content',
        '& .MuiTab-wrapper > *:first-child': {
          marginBottom: 0,
        },
      },

      '& svg, & .material-symbols-outlined': {
        fontSize: '1.6rem',
      },
      '& .MuiTab-wrapper': {
        justifyContent: 'flex-start',
        padding: '0 1rem',
        flexDirection: 'row',
        gap: '0.5rem',
      },
    },
  }),
)
